import { render, staticRenderFns } from "./MagycorpSRLDlist.vue?vue&type=template&id=56ab5976&scoped=true&"
import script from "./MagycorpSRLDlist.vue?vue&type=script&lang=js&"
export * from "./MagycorpSRLDlist.vue?vue&type=script&lang=js&"
import style0 from "./MagycorpSRLDlist.vue?vue&type=style&index=0&id=56ab5976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab5976",
  null
  
)

export default component.exports